import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";

export async function getMerchantProductsCategories(merchantUUID)
{
    //const route = publicRoutes.merchant.getCategories(merchantUUID);
    const response = await api.get(publicRoutes.merchant.products.getCategories(merchantUUID));
    if(response.success === true)
    {
        const { merchant, categories } = response.data;
        return {merchant, categories};
    }
    else
    {
        return response;
    }
}

export async function getMerchantProducts(merchantUUID,categoryUUID)
{
    console.log('LA RUTA ES ---->>>> ',publicRoutes.merchant.products.getProducts(merchantUUID,categoryUUID));
    const response = await api.get(publicRoutes.merchant.products.getProducts(merchantUUID,categoryUUID));
    if(response.success === true)
    {
        const { merchant, category, products } = response.data;
        return {merchant, category, products};
    }
    else
    {
        return response;
    }
}

export async function getProductDetails(entityUuid, productId)
{
    const url = publicRoutes.merchant.products.getProduct(entityUuid, productId);
    const response = await api.get(url);
    if(response.success === true)
    {
        const { merchant, product } = response.data;
        return { product };
    }
    return response;
}